require('./lbaSearchBy.scss');

const $inject = [];
const lbaSearchBy = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaSearchByCtrl',
    controllerAs: 'vm',
    template: require('./lbaSearchBy.html')
  }
};

lbaSearchBy.$inject = $inject;

export default lbaSearchBy;


// WEBPACK FOOTER //
// ./src/components/lbaSearchBy/lbaSearchByDir.js